export class SenhaValidator {
    senha: String;
    confirmacaoSenha: String;
    minSize: number = 6;

    constructor(senha: String, confirmacaoSenha: String) {
        this.senha = senha;
        this.confirmacaoSenha = confirmacaoSenha;
    }

    validate(addValidateMsg?): boolean {
        var valido: boolean = true;
        if (this.senha == null || this.senha.trim() == '') {
            if (addValidateMsg != null)
                addValidateMsg('- Informe a <b>Senha</b>.');
            valido = false;
        } else {
            if (!this.senha.match('[\\w_.]+')) {
                if (addValidateMsg != null)
                    addValidateMsg('- <b>Senha inválida</b>.');
                valido = false;
            } else if (this.senha.trim().length < this.minSize) {
                if (addValidateMsg != null)
                    addValidateMsg('- Senha deve conter no mínimo ' + this.minSize + ' caracteres..');
                valido = false;
            }

            if (this.confirmacaoSenha == null || this.confirmacaoSenha.trim() == '') {
                if (addValidateMsg != null)
                    addValidateMsg('- Informe a <b>Confirmação de Senha</b>.');
                valido = false;
            } else if (this.senha != this.confirmacaoSenha) {
                if (addValidateMsg != null)
                    addValidateMsg('- As <b>Senhas</b> informadas não são iguais.');
                valido = false;
            }
        }
        return valido;
    }
}


// WEBPACK FOOTER //
// ./src/util/senhavalidator.ts